// extracted by mini-css-extract-plugin
module.exports = {"bodyAlert":"AlertDelGroup_bodyAlert__B6qa6","btnCancel":"AlertDelGroup_btnCancel__14UyA"};